<template>
  <div class="cont">
    <!--<div class="navTitle">当前位置：益书宝页面 > 消息中心</div>-->
    <div class="bgcBox">
      <div class="listBox">
        <div class="tittle">{{detail.title}}</div>
        <div class="time">日期：{{detail.addtime}}</div>
        <div class="contentT" v-html="detail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "hszBanKuai",
    data() {
      return {
        detail: '',
        id: ''
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if(!this.user){
        this.$router.push("/login")
      }
      this.id = this.$route.query.id
      this.getDetail()
    },
    methods: {
      // 获取列表
      getDetail() {
        this.$api.apiAdmin.MessageDetail({
          mid: this.user.mid,
          id: this.id
        }).then(res => {
          console.log(res)
          this.detail = res.data
          this.detail.addtime = this.$tools.ZHDate(new Date(this.detail.addtime * 1000), 1)
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 修改路径
      setPath(){
        this.$router.push({
          path:'/home/xxzxBanKuai',
          query: {
            page: this.page.pageNum
          }
        })
      },
    },
    components: {
    },
    watch: {
      $route(){
        this.getDetail()
      }
    }
  }
</script>

<style scoped lang="scss">
  .bgc {
    background: url("../../../assets/images/xian.png") no-repeat bottom center !important;
    color: #007be5 !important;
  }

  .cont {
    width: 1220px;
    margin: 0 auto;
    padding-bottom: 50px;
    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }
    .bgcBox {
      width: 100%;
      min-height: 800px;
      background-color: #fff;
      .listBox {
        width: 100%;
        padding: 40px 20px;
        .tittle {
          width: 100%;
          text-align: center;
          font-size: 23px;
          color: #333333;
          font-weight: bold;
        }
        .time {
          width: 100%;
          margin-top: 30px;
          text-align: center;
          font-size: 14px;
          color: #999;
        }
        .contentT {
          width: 100%;
          margin-top: 20px;
          font-size: 14px;
          color: #666;
          text-indent: 28px;
        }
      }
      .pageBox {
        margin-top: 80px;
        display: flex;
        justify-content: center;

        span {
          padding: 6px 10px;
          border: 1px solid #f2f2f2;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
        }
      }
    }
  }

</style>
